export default {"src":"/_next/static/media/checkedIcon.615c28c3.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};